import React from 'react';
import { Button, Divider } from "@material-ui/core";
import RoomIcon from "@material-ui/icons/Room";

const LocationPreview = ({ lat, lng, thumbnail, mapsUrl }) => {
  const handleOpen = () => {
    if (mapsUrl) window.open(mapsUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={{ minWidth: "250px", maxWidth: "300px", borderRadius: "8px", overflow: "hidden", cursor: "pointer" }}>
      {thumbnail ? (
        <img
          src={thumbnail}
          alt="location preview"
          onClick={handleOpen}
          style={{ width: "100%", display: "block", maxHeight: "150px", objectFit: "cover" }}
        />
      ) : (
        <div
          onClick={handleOpen}
          style={{
            height: "80px",
            background: "linear-gradient(135deg, #e8f4f8 0%, #d1e8f0 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RoomIcon style={{ fontSize: "40px", color: "#e53935" }} />
        </div>
      )}
      {lat && lng && (
        <div style={{ padding: "4px 10px 0", fontSize: "11px", color: "#888", fontFamily: "monospace" }}>
          {parseFloat(lat).toFixed(6)}, {parseFloat(lng).toFixed(6)}
        </div>
      )}
      <Divider style={{ marginTop: "4px" }} />
      <Button fullWidth color="primary" onClick={handleOpen} disabled={!mapsUrl}>
        Visualizar en mapa
      </Button>
    </div>
  );
};

export default LocationPreview;
